var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "call-to-action"
  }, [_c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    directives: [{
      name: "scroll-animate",
      rawName: "v-scroll-animate"
    }],
    staticClass: "info-container"
  }, [_vm._t("info-box")], 2), _c('div', {
    staticClass: "asset-container"
  }, [_vm._t("image-box")], 2)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }